import { jsx } from "react/jsx-runtime";
import Skeleton from "antd/es/skeleton/Skeleton";
import classnames from "../../utils/classnames.js";
import './CarTile.css';/* empty css             */
const CarTilePaymentSkeleton = ({
  className,
  active = true
}) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-car-tile-payment", className), children: /* @__PURE__ */ jsx(Skeleton.Input, { active, size: "small", className: classnames("perxis-auto-car-tile-payment__skeleton") }) });
};
export {
  CarTilePaymentSkeleton as default
};
//# sourceMappingURL=CarTilePaymentSkeleton.js.map
